import React from "react";
import Styles from "../../../scss/orderDetails.module.scss";
import { IPlacedOrder } from "../constants";
import OrderTypeIcon from "../OrderList/OrderTypeIcon";
import { toLocalDate, toLocalTime } from "../../../yoello-lib/modules/utils/TimeConversion";
import { ICollectionPoint } from "../../ordersSetting/Forms/CollectionPointEntity";
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { OrderOnlyStatus } from "./OrderOnlyStatus";
import { useTranslation } from "react-i18next";

const DistanceUnits = {
    "KILOMETER": "km",
    "MILE": "mi"
}

interface IOrderTypeDetailsProps {
    placed_order: IPlacedOrder;
    collectionPoints: ICollectionPoint[];
    orderOnly?:boolean;
}

export function OrderTypeDetails({ placed_order, collectionPoints, orderOnly }: IOrderTypeDetailsProps) {
    return <div className={Styles.OrderTypeSection}>
        <OrderTypeIcon orderType={placed_order.placed_order_order_type} />
        {orderOnly && <OrderOnlyStatus/>}   
        <div>
            <OrderInfomation order={placed_order} collectionPoints={collectionPoints} />
        </div>
    </div>
}

interface IOrderInfomation {
    order: IPlacedOrder | undefined;
    collectionPoints: ICollectionPoint[];
}

function OrderInfomation({ order, collectionPoints }: IOrderInfomation) {
    const { t } = useTranslation();
    if (!order) { return <></>; }
    switch (order.placed_order_order_type) {
        case "COLLECTION":
            return  <p>
                        { order?.placed_order_asap_delivery_requested 
                            ? t('orderHistory.modal.Asap') 
                            : `${toLocalTime(order.placed_order_takeaway_timeslot)} , ${toLocalDate(order.placed_order_takeaway_timeslot)}`
                        }
                    </p>;
        case "TABLE_DELIVERY":
            return <p>{order.placed_order_table_area}, {order.placed_order_delivery_table}</p>;
        case "HOME_DELIVERY":
            const addr = order.placed_order_delivery_address;
            return <>
                <div style={{ paddingBottom: 10 }}>
                    {
                        order?.placed_order_asap_delivery_requested 
                            ? t('orderHistory.modal.Asap') 
                            : toLocalTime(order?.placed_order_takeaway_timeslot || order?.placed_order_est_delivery_time)
                    }
                </div>
                <div style={{ color: "grey", fontSize: "0.95em" }}>
                    <LocationOnOutlinedIcon fontSize="small" style={{ verticalAlign: "middle" }} />
                    {
                    `${(addr.full_name) 
                        ? `${addr.full_name},` 
                        : ""
                    } ${
                        (addr.apartment) 
                            ? `${addr.apartment},` 
                            : ""
                    } ${
                        addr.address 
                            ? `${addr.address},` 
                            : "" 
                    } ${
                        addr.street_address 
                            ? `${addr.street_address},` 
                            : "" 
                    } ${
                        addr.city
                    }, ${
                        addr.postcode?.toLocaleUpperCase()
                    } ${
                        order?.placed_order_delivery_distance !== undefined && order?.placed_order_distance_unit
                            ? `(${order?.placed_order_delivery_distance} ${DistanceUnits?.[order?.placed_order_distance_unit]})`
                            : ''
                    }`}
                </div>
            </>
        case "COLLECTION_POINT_PICKUP":
            const index = collectionPoints?.findIndex((item) => item.id === order.placed_order_collection_point_id)
            let name = "unallocated";
            if (index > -1) {
                name = collectionPoints[index].name;
            }

            return <p>{name}</p>;
        default:
            return <></>;
    }
}
